export default class BillingItem {
  id: string;

  taskId: string;

  description: string;

  observation: string;

  status: string;

  log: string[];

  value: number;

  constructor(obj: any) {
    this.id = obj.id || '';
    this.taskId = obj.taskId || '';
    this.description = obj.description || '';
    this.observation = obj.observation || '';
    this.status = obj.status || '';
    this.log = obj.log || [];
    this.value = obj.value || 0;
  }

  public static of(obj: any): BillingItem {
    return new BillingItem(obj || {})
  }

  public static ofList(obj: any = []): BillingItem[] {
    return obj.map(this.of)
  }
}
